import Switch from "components/switch";

const Settings = () => {
    return (
      <div className="mt-12 mb-10 relative px-2.5 md:px-3 lg:px-5 text-center">
        <h1 className="text-header mb-2 !text-center">Site Settings</h1>
        <p className="text-medium mb-4">Personalize Your BBAScan Experience to Suit Your Needs</p>
        <div className="mx-auto max-w-[680px] px-2.5 md:px-5 py-5 box bg-white dark:bg-darkPrimary overflow-hidden">
          <div className=" border-b-[1px] border-gray-100 dark:border-lightGrey py-4 text-left">
            <h2 className="text-medium !font-semibold mb-2">Address Display</h2>
            <div className="flex gap-4 justify-between">
                <div>
                    <p className="text-small mb-1">Choose desired address hash truncation format</p>
                    <p className="text-gray-700">*Note: Back truncation allows for finding address hash in page (CTRL+F)</p>
                </div>
                <div className="md:mt-0 mt-3">
                    <select className="text-small w-full min-w-[150px]">
                        <option>Middle(0x00000...00000)</option>
                        <option>Back(0x0000000000000...)</option>
                    </select>
                </div>
            </div>
          </div>
          <div className=" border-b-[1px] border-gray-100 dark:border-lightGrey py-4 text-left">
            <h2 className="text-medium !font-semibold mb-2">Ignore Tokens with Poor Reputation</h2>
            <div className="flex gap-4 justify-between">
                <div>
                    <p className="text-small mb-1">Hide all transactions of tokens that have been flagged by BBAScan as Suspicious, Unsafe, Spam or Brand Infringement from being displayed on the site.</p>
                    <p className="text-gray-700">*Note: Caution recommended when interacting with error messages that direct you to perform additional steps or visit external sites</p>
                </div>
                <div className="">
                    <Switch />
                </div>
            </div>
          </div>
          <div className=" border-b-[1px] border-gray-100 dark:border-lightGrey py-4 text-left">
            <h2 className="text-medium !font-semibold mb-2">Zero-Value Token Transfers</h2>
            <div className="flex gap-4 justify-between">
                <div>
                    <p className="text-small mb-1">Conceal token transfers with a value of zero from appearing on the website.</p>
                    <p className="text-gray-700">*Note: This feature is currently in Beta and is being enhanced continuously.</p>
                </div>
                <div className="">
                    <Switch />
                </div>
            </div>
          </div>
          <div className=" border-b-[1px] border-gray-100 dark:border-lightGrey py-4 text-left">
            <h2 className="text-medium !font-semibold mb-2">Address and Method Highlight</h2>
            <div className="flex gap-4 justify-between">
                <div>
                    <p className="text-small mb-1">Highlight every instance of an address or method on a given page when hovered over.</p>
                    <p className="text-gray-700">*Note: This is a Beta feature</p>
                </div>
                <div className="">
                    <Switch />
                </div>
            </div>
          </div>
          <div className=" border-b-[1px] border-gray-100 dark:border-lightGrey py-4 text-left">
            <h2 className="text-medium !font-semibold mb-2">Language</h2>
            <div className="flex gap-4 justify-between">
                <div>
                    <p className="text-small mb-1">Select your preferred language.</p>
                    <p className="text-gray-700"></p>
                </div>
                <div className="">
                    <select className="text-small">
                        <option>English</option>
                        <option>Русский</option>
                        <option>Deutsch</option>
                        <option>Română</option>
                    </select>
                </div>
            </div>
          </div>
          <div className=" border-b-[1px] border-gray-100 dark:border-lightGrey py-4 text-left">
            <h2 className="text-medium !font-semibold mb-2">Currency</h2>
            <div className="flex gap-4 justify-between">
                <div>
                    <p className="text-small mb-1">Select your preferred currency.</p>
                    <p className="text-gray-700"></p>
                </div>
                <div className="">
                    <select className="text-small">
                        <option>United State Doller</option>
                        <option>Australian Doller</option>
                        <option>Denmark Krone</option>
                        <option>Euro</option>
                    </select>
                </div>
            </div>
          </div>
          <div className=" border-b-[1px] border-gray-100 dark:border-lightGrey py-4 text-left">
            <h2 className="text-medium !font-semibold mb-2">Date Time Format</h2>
            <div className="flex gap-4 justify-between">
                <div>
                    <p className="text-small mb-1">Select whether to display Date Time in UTC or local (UTC+5.5) time zone</p>
                    <p className="text-gray-700"></p>
                </div>
                <div className="">
                    <select className="text-small">
                        <option>UTC</option>
                        <option>Local(+5.5)</option>
                    </select>
                </div>
            </div>
          </div>
        </div>
      </div>
    );
}

export default Settings;